// react native

// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../components/MaterialKit/MKBox";
import Breadcrumbs from "../../components/Breadcrumbs";
import MKTypography from "../../components/MaterialKit/MKTypography";
import NewsBlogCard from "../../components/Cards/BlogCards/NewsBlogCard";


function Blog(props) {


  /*
    useEffect(() => {
      let cancel = false;
      if(cancel)
        return;
  
    
        getNewsFeeds()
        .then((data) => {
          setNewsFeed(data);
          setBackdropClose(false);
        })
        .catch((err) => {
          setShowError(true);
          setBackdropClose(false);
        });
    
  
    return () => { 
            cancel = true;
          }
    }, [props]);*/

  return (
    <>
      <MKBox
        minHeight="25vh"
        width="100%"
        variant="gradient"
        bgColor="dark"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={12}
            justifyContent="left"
            alignItems="center"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <Breadcrumbs
              routes={[
                { label: "Profile", route: "/team-blog" },
                { label: "Team Blog" },
              ]}
            />
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" pt={3} pb={8}>
          <Container>
            <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
              <Grid item xs={12} md={12} sx={{ mb: 6 }}>
                <MKTypography variant="h3" color="dark">
                  Team Blog
                </MKTypography>
                <MKTypography variant="body2" color="dark" opacity={0.8}>
                  Stay Informed and Empowered: Explore Overdue's Legal Insights for Personal and Business Cover, and Debt Collection Expertise
                </MKTypography>
              </Grid>
            </Grid>
            <Grid container spacing={10}>
              <Grid key={"7"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"Court Representation: Navigating Criminal Cases"}
                  date="2025-07-10"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: 'Facing criminal charges, daunting experience requiring expert representation ensures fair trial protection rights; Legal insurance offers essential support providing access to experienced attorneys specialising in criminal law.' },
                    { type: 'bold-text', text: 'Understanding Criminal Cases' },
                    {
                      type: 'number', items:
                        [
                          "Types Criminal Cases: Criminal cases range from minor offences to serious crimes; each case requires a tailored approach and a deep understanding of criminal law.",
                          "The Importance Legal Representation: Having skilled representation crucial criminal cases navigate complexities and build strong defence.",
                          "Financial Protection: Legal insurance covers costs court representation alleviating burden allowing focus defence.",
                          "Strategic Defense Planning: Well-planned defence strategy key achieving favourable outcome; Legal insurance provides access professionals craft to execute effective defence plans.",
                        ]
                    },
                    { type: 'bold-text', text: 'Conclusion' },
                    { type: 'text', text: 'Navigating criminal cases requires expertise in strategic defence planning; Legal insurance ensures support representation needed to protect rights and achieve the best possible outcome.' },
                    { type: 'text', text: 'Call to Action: Facing criminal charges? Contact us to learn how our legal insurance services provide representation support you need.' },

                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/court-representation-navigating-criminal-cases.png`}
                />
              </Grid>
              <Grid key={"8"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"Navigating Labour Disputes with Legal Representation"}
                  date="2025-06-21"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "Labour disputes arise in the workplace involving issues such unfair dismissal discrimination wage disputes; Legal insurance provides essential support offering expert representation to navigate complex situations." },
                    { type: 'bold-text', text: "Understanding Labour Disputes" },
                    {
                      type: 'number', items:
                        [
                          "Types Labour Disputes: Common disputes include unfair dismissal workplace harassment wage disagreements; each requires a specific approach to understanding labour laws.",
                          "The Role Legal Representation: Skilled representation ensures rights protected disputes handled fairly professionally.",
                          "Cost Management: Legal insurance covers costs associated with labour dispute representation reducing burden on individuals businesses.",
                          "Strategic Resolution: Strategic approach essential resolving labour disputes effectively; Legal insurance provides access professionals to develop and implement successful strategies.",

                        ]
                    },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "Labour disputes require careful navigation expert representation; Legal insurance offers support needed to protect rights and achieve fair outcomes workplace conflict." },
                    { type: 'text', text: "Facing labour dispute? Contact us to learn how our legal insurance services provide representation support you need." },
                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/navigating-labour-disputes-with-legal-representation.png`}
                />
              </Grid>
              <Grid key={"1"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"The Art of Contract Drafting and Negotiation"}
                  date="2025-05-13"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "Contracts are the backbone of any business relationship defining the terms and conditions of engagement. Effective contract drafting and negotiation are essential skills that can safeguard your interests and prevent disputes. Legal insurance provides access to expert contract services ensuring that your agreements are robust and fair." },
                    { type: 'bold-text', text: "Key Aspects of Contract Drafting" },
                    {
                      type: 'number',
                      items: [
                        "Clarity and Precision: A well-drafted contract should be clear and precise leaving no room for ambiguity. This involves careful wording and thorough understanding of the terms.",
                        "Legal Compliance: Contracts must comply with relevant laws and regulations; Legal insurance provides access to professionals who ensure your contracts meet all legal requirements.",
                        "Risk Mitigation: Identifying and mitigating potential risks is crucial in contract drafting; this includes outlining responsibilities, liabilities and dispute resolution mechanisms.",
                        "Negotiation Skills: Effective negotiation ensures that the contract terms are favorable, balanced protecting your interests while maintaining positive relationships with other parties."
                      ]
                    },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: "text", text: "Contract drafting and negotiation are critical components of business operations; by leveraging legal insurance services you gain access to expert guidance ensuring your contracts are legally sound and strategically advantageous." },
                    { type: "text", text: "Need help with your contracts? Contact us to learn how our legal insurance services can assist you in drafting negotiating effective agreements." }
                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/the-art-of-contract-drafting-and-negotiation.png`}
                />
              </Grid>
              <Grid key={"2"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"Understanding ID Theft Protection and Legal Support"}
                  date="2025-03-20"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "Identity theft is a growing concern in today’s digital age, with criminals constantly finding new ways to exploit personal information. Legal insurance provides crucial support by offering protection, guidance, and assistance in navigating the aftermath of identity theft." },
                    { type: 'bold-text', text: "The Impact of Identity Theft" },
                    {
                      type: 'number',
                      items: [
                        "Financial Consequences - Identity theft can lead to significant financial losses, affect your credit score, and cause long-term damage.",
                        "Emotional Stress - Dealing with identity theft can be emotionally draining, leaving victims feeling violated and vulnerable.",
                        "Legal Challenges - Resolving identity theft issues often involves complex legal processes that require expert guidance and support."
                      ]
                    },
                    { type: 'bold-text', text: "How Legal Insurance Helps" },
                    {
                      type: 'bullet',
                      items: [
                        "Expert Advice - Legal insurance provides access to professionals who can guide you through the steps to resolve identity theft issues.",
                        "Financial Protection - Coverage includes costs associated with legal processes, reducing the financial impact of identity theft.",
                        "Proactive Measures - Legal insurance encourages preventive steps such as monitoring services and fraud alerts to protect your identity."
                      ]
                    },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "Identity theft is a serious threat, but with the right support, you can protect yourself and navigate the challenges that arise. Legal insurance offers the guidance and protection needed to address identity theft effectively." },
                    { type: 'bold-text', text: "Call to Action" },
                    { type: 'text', text: "Concerned about identity theft? Contact us to learn how our legal insurance services can help safeguard your identity." },
                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/understanding-id-theft-protection-and-legal-support.webp`}
                />
              </Grid>
              <Grid key={"3"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"Telephonic Legal Advice: Your First Line of Defense"}
                  date="2025-02-10"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "In the fast-paced world of business and personal affairs having immediate access to legal advice is invaluable. Telephonic legal advice serves as a first line of defence offering quick and convenient access to expert opinions and guidance. This service is a crucial component of comprehensive legal insurance providing peace of mind and timely support." },
                    { type: 'bold-text', text: "Why Telephonic Legal Advice Matters:" },
                    {
                      type: 'number',
                      items: [
                        "Immediate Access: Whether you're dealing with a contractual issue or a sudden legal query, telephonic advice provides immediate access to legal experts helping you address concerns promptly.",
                        "Cost-Effective Solutions: Rather than scheduling in-person consultations telephonic advice offers a cost-effective way to receive professional guidance saving time and resources.",
                        "Confidential and Reliable: Telephonic legal advice ensures confidentiality allowing you to discuss sensitive matters with assurance and trust.",
                        "Wide Range of Issues: From employment law to contract disputes telephonic advice covers a broad spectrum of legal issues ensuring comprehensive support."
                      ]
                    },
                    { type: 'bold-text', text: "Real-World Application" },
                    { type: 'text', text: "Imagine facing a sudden legal query about a business contract instead of waiting days for an appointment. Telephonic legal advice allows you to get immediate answers enabling you to make informed decisions swiftly." },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "Telephonic legal advice is an essential tool for individuals and businesses alike offering timely cost-effective and reliable support. By integrating this service into your legal insurance plan you ensure that expert guidance is just a phone call away." },
                    { type: 'bold-text', text: "Call to Action" },
                    { type: 'text', text: "Have you ever used telephonic legal advice? Contact us to learn how this service can benefit you." },

                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/telephonic-legal-advice-your-first-line-of-defense-ls.webp`}
                />
              </Grid>
              <Grid key={"4"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"Disciplinary Hearings: Ensuring Fairness Compliance"}
                  date="2024-12-24"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "Disciplinary hearings are a crucial aspect of maintaining workplace standards and addressing employee misconduct. Legal insurance offers support and guidance to ensure proceedings are conducted fairly and in compliance with standards." },
                    { type: 'bold-text', text: "The Importance of Disciplinary Hearings" },
                    {
                      type: 'number',
                      items: [
                        "Maintaining Workplace Standards: Disciplinary hearings uphold policies and ensure a respectful and professional work environment.",
                        "Legal Compliance: It is essential that procedures comply with laws to protect both employers and employees.",
                        "Fair Representation: Both parties should have the opportunity to present their cases, ensuring transparency and fairness.",
                      ]
                    },
                    { type: 'bold-text', text: "How Legal Insurance Helps" },
                    {
                      type: 'bullet',
                      items: [
                        "Expert Guidance: Legal insurance provides access to professionals who can advise on correct procedures and requirements for disciplinary hearings.",
                        "Representation: In some cases, having representation ensures proceedings remain fair and unbiased.",
                        "Policy Development: Experts assist in developing clear policies that align with workplace standards."
                      ]
                    },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "Disciplinary hearings are vital for maintaining order and fairness in the workplace. With legal insurance, businesses can ensure that processes are handled correctly, protecting the rights of all parties involved." },
                    { type: 'bold-text', text: "Call to Action" },
                    { type: 'text', text: "Need assistance with disciplinary hearings? Contact us to learn how our legal insurance services can support your business." },
                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/disciplinary-hearings-ensuring-fairness-compliance.webp`}
                />
              </Grid>
              <Grid key={"555"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"How Debt Collection Services Can Benefit Landlords"}
                  date="2024-11-29"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "Managing rental properties can be a rewarding endeavour, but it comes with its own set of challenges, particularly when it comes to ensuring timely rent payments. For landlords, dealing with tenant non-payment can be both stressful and financially draining. This is where professional debt collection services prove invaluable, providing structured solutions to recover owed rent efficiently and effectively." },
                    { type: 'bold-text', text: "The Role of Debt Collection Services" },
                    { type: 'text', text: "Debt collection services specialise in recovering outstanding debts, allowing landlords to maintain steady income streams and protect their investments. These services are designed to handle the complexities of rent recovery, offering a range of solutions tailored to the unique needs of landlords." },
                    { type: 'bold-text', text: "" },
                    { type: 'text', text: "Key Benefits for Landlords" },
                    {
                      type: 'number',
                      items: [
                        "Professional Expertise: Debt collection agencies employ experts who understand the legalities and intricacies of debt recovery. This ensures that every step of the process is handled professionally and in compliance with relevant laws.",
                        "Time and Resource Efficiency: Managing debt recovery in-house can be time-consuming and resource-intensive. By outsourcing to professionals, landlords can focus on other aspects of property management while ensuring effective rent recovery.",
                        "Tenant Screening Services: Many debt collection agencies offer tenant screening services, helping landlords select reliable tenants from the outset. This proactive approach minimises the risk of future payment issues.",
                        "Structured Recovery Process: Debt collection services provide a structured approach to recovering owed rent. This includes sending 'In Mora' letters, negotiating payment plans, and, if necessary, pursuing legal action.",
                        "Maintaining Relationships: By acting as an intermediary, debt collection agencies can help preserve the landlord-tenant relationship, handling sensitive situations with diplomacy and professionalism.",
                      ]
                    },
                    { type: 'bold-text', text: "Real-World Application" },
                    { type: 'text', text: "Imagine a scenario where a tenant falls behind on rent due to unforeseen circumstances. A debt collection service can step in to negotiate a payment plan that works for both parties, ensuring the landlord receives the owed rent while maintaining a positive relationship with the tenant." },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "Debt collection services are an essential tool for landlords, providing peace of mind and financial stability. By leveraging these services, landlords can effectively manage rent recovery, reduce financial stress, and focus on growing their property portfolios." },
                    { type: 'bold-text', text: "Call to Action" },
                    { type: 'text', text: "Landlords, have you used debt collection services before? What was your experience? Contact us to learn more about how we can assist with your rent recovery needs." },

                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/how-debt-collection-services-can-benefit-landlords.webp`}
                />
              </Grid>
              <Grid key={"6"} item xs={12} md={6} style={{ display: 'grid' }}>
                <NewsBlogCard
                  title={"The Importance of Legal Insurance for Businesses"}
                  date="2024-11-04"
                  author={"Overdue Team"}
                  articleContent={[
                    { type: 'text', text: "In the ever-evolving world of business, legal challenges are inevitable. From contract disputes to compliance issues, these challenges can arise unexpectedly and have significant financial implications. This is where legal insurance becomes a crucial asset for businesses, providing not just financial protection but also access to expert legal advice and representation." },
                    { type: 'bold-text', text: "Understanding Legal Insurance" },
                    { type: 'text', text: "Legal insurance is a safeguard that offers comprehensive coverage for various legal needs, including court representation, contract negotiation, and more. It acts as a buffer, allowing businesses to manage legal risks without the fear of exorbitant legal fees. This coverage ensures that businesses can focus on their core operations while having peace of mind knowing they are legally protected." },
                    { type: 'bold-text', text: "Key Benefits of Legal Insurance" },
                    {
                      type: 'number',
                      items: [
                        "Financial Protection: Legal fees can be prohibitive, especially for small and medium-sized enterprises (SMEs). Legal insurance helps mitigate these costs, offering protection against unexpected legal expenses.",
                        "Access to Expert Advice: Legal insurance provides businesses with access to experienced legal professionals who can offer advice and representation. This is invaluable in navigating complex legal landscapes.",
                        "Risk Management: By having legal insurance, businesses can proactively manage risks. This includes everything from drafting contracts to handling employee disputes, ensuring that all legal matters are addressed efficiently.",
                        "Peace of Mind: Knowing that legal challenges are covered gives business owners peace of mind, allowing them to focus on growth and innovation."
                      ]
                    },
                    { type: 'bold-text', text: "Real-World Applications" },
                    { type: 'text', text: "Consider a scenario where a business faces a contract dispute with a vendor. Without legal insurance, the company might have to allocate significant resources to legal fees, potentially impacting its financial stability. However, with legal insurance, the business can handle the dispute effectively, with expert guidance and minimal financial strain." },
                    { type: 'bold-text', text: "Conclusion" },
                    { type: 'text', text: "In today's competitive business environment, legal insurance is not just a luxury but a necessity. It empowers businesses to handle legal challenges with confidence and ensures long-term sustainability. As businesses continue to navigate the complexities of the modern world, legal insurance stands as a reliable partner in safeguarding their interests." },
                    { type: 'bold-text', text: "Call to Action" },
                    { type: 'text', text: "Have you considered legal insurance for your business? Contact us (https://www.overdue.co.za/contact-us ) to share your thoughts or learn more about how we can help protect your business." }

                  ]}
                  image={`${process.env.REACT_APP_CDN_Assets_Base}/pages/team-blog/the-importance-of-legal-insurance-for-businesses.webp`}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <br />
      </Card >
    </>
  );
}

export default Blog;